import { lang } from '@umu/ukit-lang';
import { IRadioItem, IPlainData } from '@umu/umu-types';
import React, { useState } from 'react';
import { components } from 'common';
const { DialogBody, DialogFooter, DialogFooterButton, DialogHeader, RadioList } = components;
import { transformReasonList } from '../../reportUtil';
import './reportReason.scss';

interface IProps {
    dataSource: IPlainData;
    closeDialog: () => void;
    onReportCallback: (reasonType: string) => void;
}

export const ReportReason = (props: IProps) => {
    const { closeDialog, onReportCallback, dataSource } = props;
    const [checkedId, setCheckedId] = useState('');
    const contentReasonList = transformReasonList(dataSource);

    const onReport = () => {
        closeDialog();
        onReportCallback(checkedId);
    };

    const onChange = (data: IRadioItem) => {
        setCheckedId(`${data.value}`);
    };

    return (
        <div className="ugc-report-reason-dialog">
            <DialogHeader>
                <div className="title">{lang('举报问题')}</div>
            </DialogHeader>
            <DialogBody>
                <RadioList list={contentReasonList} checked={checkedId} onChange={onChange}></RadioList>
            </DialogBody>
            <DialogFooter>
                <DialogFooterButton onClick={closeDialog}>{lang('取消')}</DialogFooterButton>
                <DialogFooterButton onClick={onReport} disabled={!checkedId}>
                    {lang('举报')}
                </DialogFooterButton>
            </DialogFooter>
        </div>
    );
};
